export const FOLDER_LIST = [
  {
    type: 'allContent',
    label: 'My Uploads',
    icon: 'laptop'
  }
]

export const EXTERNAL_LIST = [
  {
    type: 'paperflite',
    label: 'Paperflite',
    icon: 'paperflite-logo'
    
  },
  {
    type: 'link',
    label: 'Link (URL)',
    icon: 'web'
  }
]